import { render } from "./Slides.vue?vue&type=template&id=b67b6b54&ts=true"
import script from "./Slides.vue?vue&type=script&lang=ts"
export * from "./Slides.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__